export default __webpack_public_path__ + "static/aws-300x180-632b2d92adf3808944a69a20458ce7ac.png";